import { Component, Input, OnInit } from '@angular/core';
import { ConfirmationService } from 'primeng/api';
import { MessageService, SelectItem } from 'primeng';
import {
  JobScreenServiceTypeJob,
  JobScreenServiceTypeTask,
} from 'src/app/interfaces/screen-specific/job-screen';
import { EventService, JobsService, TaskService } from '../../../../services';
import { JobStatus } from '../../../../enums/job-status';
import { Message } from '../../../../classes/Message';

@Component({
  selector: 'vme-job-screen-tasks-service-type',
  templateUrl: './vme-job-screen-tasks-service-type.component.html',
  styleUrls: ['./vme-job-screen-tasks-service-type.component.scss'],
})
export class VMEJobScreenTasksServiceTypeComponent implements OnInit {
  @Input('jobId') jobId!: number;
  @Input('orderId') orderId!: number;
  @Input('serviceTypeTask') serviceTypeTask!: JobScreenServiceTypeTask;
  @Input('organisationId') organisationId!: number;
  @Input('organisationTypeId') organisationTypeId!: number;

  showEditActualTaskTypeDialog: boolean;
  actualTaskTypeId: number;
  taskTypeId: number;

  job: JobScreenServiceTypeJob;
  taskTypes: SelectItem[];
  loadingJob: boolean;

  constructor(
    private taskService: TaskService,
    private confirmationService: ConfirmationService,
    private messageService: MessageService,
    private jobService: JobsService,
    private eventService: EventService,
  ) {}

  ngOnInit() {
    this.initEngineiusTaskTypes();
    this.loadJob(this.jobId).then(() => {});
  }

  contentLoading() {
    return this.loadingJob || !this.serviceTypeTask;
  }

  allowServiceTypeEdit() {
    return (
      this.serviceTypeTask?.order?.job?.statusId == JobStatus.Created ||
      this.serviceTypeTask?.statusId == JobStatus.Completed ||
      this.serviceTypeTask?.statusId == JobStatus.Closed
    );
  }

  confirmMultiOrderTaskType() {
    let hasDiffTaskOrderType = false;

    this.job.orders.forEach((order) => {
      let diffOrderTask = order.tasks.find(
        (t) => t.taskTypeId != this.taskTypeId && t.id != this.serviceTypeTask.id,
      );
      if (diffOrderTask) hasDiffTaskOrderType = true;
    });

    if (this.job.orders.length > 1 && hasDiffTaskOrderType) {
      // notify of some order with mismatched task types
      this.confirmationService.confirm({
        message: `This job has different types of tasks. Please confirm that changing this task type will still allow the tasks within the job to be completed by an individual supplier. Do you want to continue?`,
        acceptLabel: 'Yes',
        rejectLabel: 'No',
        accept: () => {
          this.saveActualTaskType();
        },
        reject: () => {},
      });
    } else {
      this.saveActualTaskType();
    }
  }

  async loadJob(jobId: number) {
    this.loadingJob = true;
    return this.jobService.getForComponent(jobId, 'job-screen-service-type').then((job) => {
      this.job = job as JobScreenServiceTypeJob;
      this.loadingJob = false;
    });
  }

  saveActualTaskType() {
    this.serviceTypeTask.actualTaskTypeId = this.actualTaskTypeId;
    this.serviceTypeTask.taskTypeId = this.taskTypeId;
    this.serviceTypeTask.jobId = this.serviceTypeTask.order.job.id;

    this.taskService
      .saveActualTaskType(this.serviceTypeTask)
      .then(() => {
        let engType = this.taskTypes.find((x) => x.value == this.serviceTypeTask.actualTaskTypeId);
        if (engType && this.serviceTypeTask.actualTaskTypeId) {
          this.serviceTypeTask.actualTaskTypeName = engType.label;
        }

        let cusType = this.taskTypes.find((x) => x.value == this.serviceTypeTask.taskTypeId);
        if (cusType && this.serviceTypeTask.taskTypeId) {
          this.serviceTypeTask.taskTypeName = cusType.label;
        }

        this.showEditActualTaskTypeDialog = false;
        this.messageService.add(
          Message.Success('Engineius Movement Type updated', 'Engineius Movement Type'),
        );

        //update local
        this.job.orders.forEach((order, orderIndex) => {
          order.tasks.forEach((task, taskIndex) => {
            if (task.id == this.serviceTypeTask.id) {
              this.job.orders[orderIndex].tasks[taskIndex].taskTypeId = this.taskTypeId;
              this.job.orders[orderIndex].tasks[taskIndex].actualTaskTypeId = this.actualTaskTypeId;
            }
          });
        });

        this.eventService.JobScreenEvent.emit({
          event: 'task-type-changed',
          data: { jobId: this.jobId },
        });

        this.showEditActualTaskTypeDialog = false;
      })
      .catch((err) => {
        this.messageService.add(Message.Error(`Error: ${err.error}`, 'Task Type Update'));
      });
  }

  editActualTaskType(task: JobScreenServiceTypeTask) {
    this.actualTaskTypeId = task.actualTaskTypeId;
    this.showEditActualTaskTypeDialog = true;
    this.taskTypeId = task.taskTypeId;
  }

  initEngineiusTaskTypes() {
    this.taskTypes = [];
    this.taskTypes.push({ label: 'Select task type', value: null });
    this.taskService.getActualTaskTypes().then((res) => {
      res.forEach((x: any) => this.taskTypes.push({ label: x.abbr, value: x.id }));
    });
  }
}
